module.exports = __webpack_public_path__ + "img/activity.ff76cbc6.svg";